import WorkLogForm from "../workLogForm"
//--------------------------------------------------------------------------------------------
export default function TestManholeForm({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Manhole No.", type: "text", required: true, docNum: true}, 
        {title: "Cancel", type: "radio", default: "No", required: true}, 
        {title: "Coordniates", type: "latlng", parentNo: "Cancel"}, 
        {title: "Type", example: "Sewer / Storm", type: "text", parentNo: "Cancel", required: true}, 
        {title: "Material Type", type: "text", parentNo: "Cancel", required: true}, 
        {title: "Location", example: "Cross streets", type: "text", parentNo: "Cancel", required: true}, 
        {title: "Depth to Bottom", example: "Bottom of Manhole", type: "number", parentNo: "Cancel", required: true, suffix: <span className = "ml-2">inches</span>}, 
        // Inverts
        {title: "Swing Tie 1", type: "text", parentNo: "Cancel", required: true}, 
        {title: "Swing Tie 2", type: "text", parentNo: "Cancel", required: true}, 
        {title: "Swing Tie 3", type: "text", parentNo: "Cancel", required: true}, 
        {title: "Notes", type: "textarea", required: true}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            items = {items}
            {...rest}
        />
    )    
}